export enum TaskManagerTaskStatus {
  unresolved = 1,
  urgent,
  resolved,
}

export enum TaskManagerReportStatus {
  unresolved = 1,
  resolved,
}